import loadable from '@loadable/component';

// 懒加载组件
const HospitalInventoryDetailQuery = loadable(() => import('./hospitalInventoryDetailQuery/HospitalInventoryDetailQuery'));
const DepartmentConsumeDetailQuery = loadable(() => import('./departmentConsumeDetailQuery/DepartmentConsumeDetailQuery'));
const CstStatementConfirmationManagement = loadable(() => import('./cstStatementConfirmationManagement/CstStatementConfirmationManagement'));
const CstStatementConfirmationModify = loadable(() => import('./cstStatementConfirmationManagement/cstStatementConfirmationModify/CstStatementConfirmationModify'));
const InvoiceManagement2308 = loadable(() => import('./invoiceManagement2308/InvoiceManagement'));


export const subRoutes = [
  {
    path: '/HospitalInventoryDetailQuery',
    component: HospitalInventoryDetailQuery
  },
  {
    // 科室消耗明细查询
    path: '/DepartmentConsumeDetailQuery',
    component: DepartmentConsumeDetailQuery
  },
  {
    path: '/CstStatementConfirmationManagement',
    component: CstStatementConfirmationManagement
  },
  {
    path: '/CstStatementConfirmationModify',
    component: CstStatementConfirmationModify
  },
  {
    // M828258008 【2308】供应商：供应商发票查询明细
    path: '/InvoiceManagement2308',
    component: InvoiceManagement2308
  }
];
